class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.onBodyClick = this.handleCloseClick.bind(this);
    this.onBodyOpenClick = this.handleOpenClick.bind(this);
    this.drawer = this.querySelector(".js-mobile-menu");
    this.overlay = this.querySelector(".js-menu-overlay");

    const btnOpen = document.querySelector(".js-btn-open-menu");
    const btnClose = document.querySelector(".js-btn-close-menu");

    btnOpen.addEventListener("click", this.onBodyOpenClick);
    btnClose.addEventListener("click", this.onBodyClick);
  }

  open() {
    console.log("open");
    this.classList.toggle("pointer-events-none");
    this.overlay.classList.remove("opacity-0");
    this.overlay.classList.add("opacity-100");
    this.drawer.classList.remove("translate-x-full");
    this.drawer.classList.add("translate-x-0");

    this.overlay.addEventListener("click", this.onBodyClick);
  }

  close() {
    console.log("close");
    // this.setAttribute("hidden", true);
    this.classList.toggle("pointer-events-none");
    this.overlay.classList.remove("opacity-100");
    this.overlay.classList.add("opacity-0");
    this.drawer.classList.remove("translate-x-0");
    this.drawer.classList.add("-translate-x-full");

    this.overlay.removeEventListener("click", this.onBodyClick);

    // removeTrapFocus(this.activeElement);
  }

  handleCloseClick(evt) {
    const target = evt.target;

    this.close();
  }

  handleOpenClick(evt) {
    this.open();
  }
}

customElements.define("mobile-menu", MobileMenu);
